import React, { useState } from 'react';

const TablaExcepciones = ({
  excepciones,
  onEditar,
  onEliminar,
  loading = false
}) => {
  const [filtro, setFiltro] = useState('todos');
  const [confirmDelete, setConfirmDelete] = useState(null);

  const excecionesFiltered = excepciones.filter(exc => {
    if (filtro === 'cerrado') return exc.tipo === 'cerrado';
    if (filtro === 'especial') return exc.tipo === 'horario_especial';
    return true;
  });

  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  };

  const getTipoColor = (tipo) => {
    if (tipo === 'cerrado') return { bg: '#fee2e2', color: '#991b1b', texto: 'Cerrado' };
    if (tipo === 'horario_especial') return { bg: '#fef3c7', color: '#92400e', texto: 'Horario Especial' };
    return { bg: '#dbeafe', color: '#0c4a6e', texto: 'Otro' };
  };

  const handleEliminar = async (excepcionId) => {
    await onEliminar(excepcionId);
    setConfirmDelete(null);
  };

  const buttonStyle = {
    padding: '0.5rem 0.75rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '600',
    transition: 'all 0.2s',
    marginRight: '0.5rem'
  };

  return (
    <div style={{ marginTop: '2rem' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1.5rem'
      }}>
        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#374151', margin: 0 }}>
          📋 Excepciones del Mes
        </h2>

        {/* Filtro */}
        <select
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          style={{
            border: '2px solid rgba(59, 130, 246, 0.3)',
            borderRadius: '8px',
            padding: '0.5rem 0.75rem',
            fontSize: '0.9rem',
            backgroundColor: '#fafafa',
            cursor: 'pointer'
          }}
          disabled={loading}
        >
          <option value="todos">Todas</option>
          <option value="cerrado">Solo Cerrados</option>
          <option value="especial">Solo Horarios Especiales</option>
        </select>
      </div>

      {excecionesFiltered.length === 0 ? (
        <div style={{
          padding: '2rem',
          backgroundColor: '#f0fdf4',
          border: '2px dashed #86efac',
          borderRadius: '8px',
          textAlign: 'center',
          color: '#166534'
        }}>
          <p style={{ margin: 0, fontSize: '0.95rem' }}>
            ✅ No hay excepciones en este mes
          </p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: 'white',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
                  Fecha
                </th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
                  Tipo
                </th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
                  Horario
                </th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
                  Motivo
                </th>
                <th style={{ padding: '1rem', textAlign: 'center', fontWeight: '700', color: '#374151' }}>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {excecionesFiltered.map((exc) => {
                const tipoInfo = getTipoColor(exc.tipo);
                return (
                  <tr
                    key={exc.id}
                    style={{
                      borderBottom: '1px solid #e5e7eb',
                      backgroundColor: exc.esTemporal ? '#fffbeb' : 'white'
                    }}
                  >
                    <td style={{ padding: '1rem', color: '#374151', fontWeight: '500' }}>
                      {formatearFecha(exc.fecha)}
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '0.25rem 0.75rem',
                        borderRadius: '6px',
                        backgroundColor: tipoInfo.bg,
                        color: tipoInfo.color,
                        fontSize: '0.9rem',
                        fontWeight: '600'
                      }}>
                        {tipoInfo.texto}
                      </span>
                      {exc.esTemporal && (
                        <span style={{
                          marginLeft: '0.5rem',
                          fontSize: '0.75rem',
                          color: '#d97706',
                          fontWeight: '600'
                        }}>
                          (Temporal)
                        </span>
                      )}
                    </td>
                    <td style={{ padding: '1rem', color: '#6b7280' }}>
                      {exc.tipo === 'horario_especial'
                        ? `${exc.hora_inicio} - ${exc.hora_fin}`
                        : '—'}
                    </td>
                    <td style={{ padding: '1rem', color: '#6b7280', maxWidth: '200px' }}>
                      {exc.motivo || '—'}
                    </td>
                    <td style={{ padding: '1rem', textAlign: 'center' }}>
                      <button
                        onClick={() => onEditar(exc)}
                        style={{
                          ...buttonStyle,
                          backgroundColor: '#3b82f6',
                          color: 'white'
                        }}
                        disabled={loading}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
                      >
                        ✏️ Editar
                      </button>
                      <button
                        onClick={() => setConfirmDelete(exc.id)}
                        style={{
                          ...buttonStyle,
                          backgroundColor: '#ef4444',
                          color: 'white'
                        }}
                        disabled={loading}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                      >
                        🗑️ Eliminar
                      </button>

                      {/* Confirmación eliminar */}
                      {confirmDelete === exc.id && (
                        <div style={{
                          display: 'inline-block',
                          marginLeft: '0.5rem',
                          padding: '0.5rem',
                          backgroundColor: '#fee2e2',
                          borderRadius: '6px',
                          border: '1px solid #fca5a5'
                        }}>
                          <button
                            onClick={() => handleEliminar(exc.id)}
                            style={{
                              ...buttonStyle,
                              backgroundColor: '#dc2626',
                              color: 'white',
                              marginRight: '0.25rem'
                            }}
                            disabled={loading}
                          >
                            Confirmar
                          </button>
                          <button
                            onClick={() => setConfirmDelete(null)}
                            style={{
                              ...buttonStyle,
                              backgroundColor: '#6b7280',
                              color: 'white'
                            }}
                            disabled={loading}
                          >
                            Cancelar
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Stats */}
      <div style={{
        marginTop: '1.5rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '1rem'
      }}>
        <div style={{
          padding: '1rem',
          backgroundColor: '#eff6ff',
          borderRadius: '8px',
          border: '1px solid #bfdbfe',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#1e40af', fontWeight: '600' }}>
            Total
          </p>
          <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: '700', color: '#0c4a6e' }}>
            {excepciones.length}
          </p>
        </div>
        <div style={{
          padding: '1rem',
          backgroundColor: '#fee2e2',
          borderRadius: '8px',
          border: '1px solid #fca5a5',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#991b1b', fontWeight: '600' }}>
            Cerrados
          </p>
          <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: '700', color: '#7f1d1d' }}>
            {excepciones.filter(e => e.tipo === 'cerrado').length}
          </p>
        </div>
        <div style={{
          padding: '1rem',
          backgroundColor: '#fef3c7',
          borderRadius: '8px',
          border: '1px solid #fcd34d',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#92400e', fontWeight: '600' }}>
            Horarios Especiales
          </p>
          <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: '700', color: '#78350f' }}>
            {excepciones.filter(e => e.tipo === 'horario_especial').length}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TablaExcepciones;
